import {
    INVALID_ID,
    EMPTY_STRING,
    INVALID_DATE,
} from '@Utils/constants'

// List of Onboarding
export const getDefaultFilters = ({ onboardingList }) => onboardingList.searchFilter;
export const getListPageTitle = ({ onboardingList }) => onboardingList.searchLabel;
export const getListConfirmModal = ({ onboardingList }) => onboardingList.confirmModal;
export const getChangeStatusData = ({ onboardingList }) => onboardingList.changeStatusData;
export const getListAlertModal = ({ onboardingList }) => onboardingList.alert;
export const getListExportModal = ({ onboardingList }) => onboardingList.exportModal;
//
// Table selectors
export const getCurrentPage = ({ onboardingList }) => onboardingList.searchFilter.Pagination.Page;
export const getSortModel = ({ onboardingList }) => onboardingList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ onboardingList }) => onboardingList.resultTable.rowsPerPage;
export const isTableLoading = ({ onboardingList }) => onboardingList.resultTable.loading;
export const getTableData = ({ onboardingList }) => onboardingList.resultTable.data;
export const getTotalCount = ({ onboardingList }) => onboardingList.resultTable.totalCount;
export const getTableSelectedRows = ({ onboardingList }) => onboardingList.resultTable.selectedRows;

// Onboarding Add form
export const getAddFormData = ({ onboardingAdd }) => onboardingAdd.addForm;
export const getAlertModelData = ({ onboardingAdd }) => onboardingAdd.alert;
export const getShowLoading = ({ onboardingAdd }) => onboardingAdd.loading;
export const getAddMode = ({ onboardingAdd }) => onboardingAdd.mode;
export const getAddEditable = ({ onboardingAdd }) => onboardingAdd.isEditable;
export const getHolidayDates = ({ onboardingAdd }) => onboardingAdd.holidayDates;
export const getAddEmailTemplate = ({ onboardingAdd }) => onboardingAdd.emailTemplate;

// Onboarding Detail form
export const getDetailMode = ({ onboardingDetail }) => onboardingDetail.mode;
export const getDetailTitle = ({ onboardingDetail }) => onboardingDetail.title;
export const getDetailData = ({ onboardingDetail }) => onboardingDetail.detailForm;
export const getParticipants = ({ onboardingDetail }) => onboardingDetail.participants;
export const isDetailLoading = ({ onboardingDetail }) => onboardingDetail.loading;
export const getTableDataDetail = ({ onboardingDetail }) => onboardingDetail.resultTable.data;
export const getFormTitle = ({ onboardingDetail }) => onboardingDetail.title;
export const getEditable = ({ onboardingDetail }) => onboardingDetail.isEditable;
export const getDetailAlertModal = ({ onboardingDetail }) => onboardingDetail.alert;
export const getDetailConfirmModal = ({ onboardingDetail }) => onboardingDetail.confirmModal;
export const hasLoadedData = ({ onboardingDetail }) => onboardingDetail.hasLoadedData;
export const getDetailEmailTemplate = ({ onboardingDetail }) => onboardingDetail.emailTemplate;

export const validateAddForm = (tableData = [] ) => {
    let errors = {};
    
    tableData.forEach((row) => {
        if (!row.trainingCategory) {
            errors[`trainingCategory-${row.id}`] = "Training Category is required!";
        }
        if (!row.trainingMasterModuleID) {
            errors[`trainingMasterModuleID-${row.id}`] = "Training Name is required!";
        }
        if (!row.facilitator) {
            errors[`facilitator-${row.id}`] = "Facilitator is required!";
        }
        if (!row.startTrainingDate || row.startTrainingDate === EMPTY_STRING) {
            errors[`startTrainingDate-${row.id}`] = "Start Date is required!";
        } else if (row.startTrainingDate === INVALID_DATE) {
            errors[`startTrainingDate-${row.id}`] = "Invalid Start Date!";
        }
        if (!row.onboardingType) {
            errors[`onboardingType-${row.id}`] = "Type is required!";
        }
        if (!row.onboardingStatus) {
            errors[`onboardingStatus-${row.id}`] = "Status is required!";
        }
        if (!row.selectedParticipants || row.selectedParticipants.length === 0) {
            errors[`selectedParticipants-${row.id}`] = "At least one participant must be selected!";
        }
    });

    return errors;
};
